import { render, staticRenderFns } from "./InquiryAssignedCustomer.vue?vue&type=template&id=fdb8778a&scoped=true&"
import script from "./InquiryAssignedCustomer.vue?vue&type=script&lang=js&"
export * from "./InquiryAssignedCustomer.vue?vue&type=script&lang=js&"
import style0 from "./InquiryAssignedCustomer.vue?vue&type=style&index=0&id=fdb8778a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb8778a",
  null
  
)

export default component.exports